(function () {
    'use strict';

    var UMBRAL_SWIPE = 35;
    var UMBRAL_AXIS_LOCK = 5;
    var QUERY_NO_TACTIL = '(hover: hover) and (pointer: fine)';

    // Fuerzo de Grid para pantallas desktop
    function esNoTactil() {
        return window.matchMedia(QUERY_NO_TACTIL).matches || window.innerWidth > 700;
    }

    function iniciarNoTactil(seccion) {
        var tarjetas = Array.from(seccion.querySelectorAll('.coleccion-swipe__tarjeta'));

        if (tarjetas.length === 0) return;

        tarjetas.forEach(function (tarjeta) {
            tarjeta.style.cssText = '';
            tarjeta.classList.remove(
                'coleccion-swipe__tarjeta--arrastrando',
                'coleccion-swipe__tarjeta--presionada',
                'coleccion-swipe__tarjeta--rebote',
                'coleccion-swipe__tarjeta--activa',
                'coleccion-swipe__tarjeta--saliendo',
                'coleccion-swipe__tarjeta--oculta'
            );
        });

        return {
            destruir: function () {
                tarjetas.forEach(function (tarjeta) {
                    tarjeta.replaceWith(tarjeta.cloneNode(true));
                });
            }
        };
    }

    function iniciarMobile(seccion) {
        var viewport = seccion.querySelector('.coleccion-swipe__viewport');
        var tarjetas = Array.from(seccion.querySelectorAll('.coleccion-swipe__tarjeta'));
        var total = tarjetas.length;
        var tarjetaActual = 0;
        var arrastrando = false;
        var presionando = false;
        var bloqueadoPorArrastre = false;
        var scrollPosicionInicial = 0;

        if (!viewport || total === 0) return null;

        function calcularOffset(indice, base) {
            var offset = indice - base;
            if (offset > total / 2) offset -= total;
            if (offset < -total / 2) offset += total;
            return offset;
        }

        function aplicarEstilos(tarjeta, offset, zIndexOverride) {
            var offsetBase = 50;
            var scaleBase = offset === 0 ? 1 : 0.85;

            var translateX = offset * offsetBase;
            var zIndex = zIndexOverride !== undefined ? zIndexOverride : (total - Math.abs(offset));
            var transformValue = 'translateX(' + translateX + 'px) scale(' + scaleBase + ')';

            tarjeta.style.transform = transformValue;
            tarjeta.style.zIndex = zIndex;
            tarjeta.style.pointerEvents = offset === 0 ? 'auto' : 'none';
            tarjeta.classList.toggle('coleccion-swipe__tarjeta--activa', offset === 0);
        }

        function posicionar() {
            tarjetas.forEach(function (tarjeta, indice) {
                tarjeta.style.transition = '';
                var offset = calcularOffset(indice, tarjetaActual);
                aplicarEstilos(tarjeta, offset);
            });
        }

        function irA(nuevoIndice) {
            var anteriorIndice = tarjetaActual;
            tarjetaActual = (nuevoIndice + total) % total;

            tarjetas.forEach(function (tarjeta, indice) {
                var offsetAnterior = calcularOffset(indice, anteriorIndice);
                var offsetNuevo = calcularOffset(indice, tarjetaActual);
                var esWrap = (offsetAnterior < 0 && offsetNuevo > 0) || (offsetAnterior > 0 && offsetNuevo < 0);

                if (esWrap) {
                    tarjeta.style.transition = 'none';
                    aplicarEstilos(tarjeta, offsetNuevo, 0);
                    tarjeta.offsetHeight;
                    requestAnimationFrame(function () {
                        tarjeta.style.transition = 'z-index 0ms 100ms';
                        tarjeta.style.zIndex = total - Math.abs(offsetNuevo);
                    });
                } else {
                    tarjeta.style.transition = '';
                    aplicarEstilos(tarjeta, offsetNuevo);
                }
            });

            resetearScrollSafari();
        }

        function siguiente() { irA(tarjetaActual + 1); }
        function anterior() { irA(tarjetaActual - 1); }

        function quitarPresion() {
            presionando = false;
            tarjetas.forEach(function (tarjeta) {
                tarjeta.classList.remove('coleccion-swipe__tarjeta--presionada');
            });
        }

        function aplicarRebote(tarjeta) {
            tarjeta.classList.remove('coleccion-swipe__tarjeta--presionada');
            tarjeta.classList.add('coleccion-swipe__tarjeta--rebote');
            tarjeta.addEventListener('animationend', function limpiar() {
                tarjeta.classList.remove('coleccion-swipe__tarjeta--rebote');
                tarjeta.removeEventListener('animationend', limpiar);
            });
        }

        function resetearScrollSafari() {
            requestAnimationFrame(function () {
                window.scrollTo(window.scrollX, scrollPosicionInicial);
                requestAnimationFrame(function () {
                    window.scrollTo(window.scrollX, scrollPosicionInicial);
                });
            });
        }

        var touch = {
            startX: 0, startY: 0, currentX: 0, currentY: 0,
            deltaX: 0, deltaY: 0, direccion: null,
            inicioCapturado: false, ultimoTiempo: 0
        };

        function resetTouch() {
            touch.startX = 0; touch.startY = 0;
            touch.currentX = 0; touch.currentY = 0;
            touch.deltaX = 0; touch.deltaY = 0;
            touch.direccion = null; touch.inicioCapturado = false;
        }

        function onTouchStart(e) {
            if (esNoTactil()) return;
            scrollPosicionInicial = window.scrollY || window.pageYOffset;
            var t = e.touches[0];
            touch.startX = t.clientX;
            touch.startY = t.clientY;
            touch.currentX = t.clientX;
            touch.currentY = t.clientY;
            touch.direccion = null;
            touch.inicioCapturado = true;
            touch.ultimoTiempo = Date.now();
            arrastrando = false;
            bloqueadoPorArrastre = false;
            quitarPresion();
            var tarjetaFrente = tarjetas[tarjetaActual];
            tarjetaFrente.classList.remove('coleccion-swipe__tarjeta--rebote');
        }

        function onTouchMove(e) {
            if (esNoTactil()) return;
            if (!touch.inicioCapturado) return;

            var t = e.touches[0];
            touch.currentX = t.clientX;
            touch.currentY = t.clientY;
            touch.deltaX = touch.currentX - touch.startX;
            touch.deltaY = touch.currentY - touch.startY;

            var absDeltaX = Math.abs(touch.deltaX);
            var absDeltaY = Math.abs(touch.deltaY);

            if (touch.direccion === null && (absDeltaX >= UMBRAL_AXIS_LOCK || absDeltaY >= UMBRAL_AXIS_LOCK)) {
                if (absDeltaX > absDeltaY * 2) {
                    touch.direccion = 'horizontal';
                } else {
                    touch.direccion = 'vertical';
                }
            }

            if (touch.direccion === 'vertical') {
                if (arrastrando) {
                    arrastrando = false;
                    var tarjetaFrente = tarjetas[tarjetaActual];
                    tarjetaFrente.classList.remove('coleccion-swipe__tarjeta--arrastrando');
                    tarjetaFrente.style.transition = '';
                    posicionar();
                }
                return;
            }

            if (touch.direccion === 'horizontal') {
                if (e.cancelable) {
                    e.preventDefault();
                    e.stopPropagation();
                }
                window.scrollTo(window.scrollX, scrollPosicionInicial);

                if (!arrastrando) {
                    arrastrando = true;
                    bloqueadoPorArrastre = true;
                    var tarjetaFrente = tarjetas[tarjetaActual];
                    tarjetaFrente.classList.remove('coleccion-swipe__tarjeta--rebote');
                    tarjetaFrente.classList.add('coleccion-swipe__tarjeta--arrastrando');
                }

                var rotation = touch.deltaX / 20;
                var tarjetaFrente = tarjetas[tarjetaActual];
                tarjetaFrente.style.transform = 'translateX(' + touch.deltaX + 'px) rotate(' + rotation + 'deg) scale(0.975)';
            }
        }

        function onTouchEnd(e) {
            if (esNoTactil()) return;
            if (!touch.inicioCapturado) return;

            if (!arrastrando) {
                resetTouch();
                return;
            }

            var tarjetaFrente = tarjetas[tarjetaActual];
            tarjetaFrente.style.transition = '';
            tarjetaFrente.classList.remove('coleccion-swipe__tarjeta--arrastrando');

            var tiempoTranscurrido = Date.now() - touch.ultimoTiempo;
            var velocidad = Math.abs(touch.deltaX) / tiempoTranscurrido;
            var esSwipeRapido = velocidad > 0.3;
            var esSwipeLargo = Math.abs(touch.deltaX) > UMBRAL_SWIPE;

            if ((esSwipeRapido || esSwipeLargo) && Math.abs(touch.deltaX) > Math.abs(touch.deltaY)) {
                if (touch.deltaX < 0) {
                    siguiente();
                } else {
                    anterior();
                }
            } else {
                posicionar();
                resetearScrollSafari();
            }

            arrastrando = false;
            resetTouch();
            setTimeout(function () { bloqueadoPorArrastre = false; }, 100);
        }

        function onTouchCancel() {
            if (esNoTactil()) return;
            if (arrastrando) {
                arrastrando = false;
                bloqueadoPorArrastre = false;
                var tarjetaFrente = tarjetas[tarjetaActual];
                tarjetaFrente.classList.remove('coleccion-swipe__tarjeta--arrastrando');
                tarjetaFrente.style.transition = '';
                posicionar();
                resetearScrollSafari();
            }
            resetTouch();
        }

        viewport.addEventListener('touchstart', onTouchStart, { passive: true });
        viewport.addEventListener('touchmove', onTouchMove, { passive: false, capture: true });
        viewport.addEventListener('touchend', onTouchEnd, { passive: true, capture: true });
        viewport.addEventListener('touchcancel', onTouchCancel, { passive: true, capture: true });

        viewport.addEventListener('pointermove', function (e) {
            if (esNoTactil()) return;
            if (arrastrando && touch.direccion === 'horizontal') {
                if (e.cancelable) e.preventDefault();
                window.scrollTo(window.scrollX, scrollPosicionInicial);
            }
        }, { passive: false });

        tarjetas.forEach(function (tarjeta, indice) {
            var pressTimer = null;

            tarjeta.addEventListener('click', function (e) {
                if (esNoTactil()) return;

                if (bloqueadoPorArrastre || indice !== tarjetaActual) {
                    e.preventDefault();
                    e.stopPropagation();
                    return;
                }

                if (e.target.tagName.toLowerCase() === 'button' || e.target.closest('button')) {
                    return;
                }

                var link = tarjeta.getAttribute('data-url');
                if (link && !e.target.closest('a')) {
                    e.preventDefault();
                    tarjeta.classList.add('coleccion-swipe__tarjeta--presionada');
                    setTimeout(function () {
                        aplicarRebote(tarjeta);
                        setTimeout(function () {
                            window.location.href = link;
                        }, 300);
                    }, 120);
                }
            });

            tarjeta.addEventListener('touchstart', function () {
                if (esNoTactil()) return;
                if (indice !== tarjetaActual) return;
                pressTimer = setTimeout(function () {
                    presionando = true;
                    tarjeta.classList.remove('coleccion-swipe__tarjeta--rebote');
                    tarjeta.classList.add('coleccion-swipe__tarjeta--presionada');
                }, 500);
            }, { passive: true });

            tarjeta.addEventListener('touchend', function () {
                clearTimeout(pressTimer);
                if (presionando && indice === tarjetaActual) {
                    aplicarRebote(tarjeta);
                }
            }, { passive: true });

            tarjeta.addEventListener('touchcancel', function () {
                clearTimeout(pressTimer);
            }, { passive: true });
        });

        document.addEventListener('pointerup', function () {
            if (esNoTactil()) return;
            if (presionando) {
                var tarjetaActiva = tarjetas[tarjetaActual];
                aplicarRebote(tarjetaActiva);
            }
        });

        document.addEventListener('pointercancel', function () {
            if (esNoTactil()) return;
            quitarPresion();
            if (arrastrando) {
                arrastrando = false;
                bloqueadoPorArrastre = false;
                posicionar();
                resetearScrollSafari();
            }
        });

        var scrollMonitorTimeout;
        window.addEventListener('scroll', function () {
            if (esNoTactil()) return;
            clearTimeout(scrollMonitorTimeout);
            if (arrastrando) {
                window.scrollTo(window.scrollX, scrollPosicionInicial);
            } else {
                scrollMonitorTimeout = setTimeout(function () {
                    if (!arrastrando) {
                        scrollPosicionInicial = window.scrollY || window.pageYOffset;
                    }
                }, 100);
            }
        }, { passive: true });

        posicionar();

        return {
            posicionar: posicionar,
            limpiar: function () {
                tarjetas.forEach(function (tarjeta) {
                    tarjeta.style.cssText = '';
                    tarjeta.classList.remove(
                        'coleccion-swipe__tarjeta--arrastrando',
                        'coleccion-swipe__tarjeta--presionada',
                        'coleccion-swipe__tarjeta--rebote',
                        'coleccion-swipe__tarjeta--activa'
                    );
                });
            }
        };
    }

    function iniciarInstancia(seccion) {
        var modoActual = null;
        var instanciaMobile = null;
        var instanciaNoTactil = null;

        var mqHover = window.matchMedia(QUERY_NO_TACTIL);
        var mqWidth = window.matchMedia('(min-width: 701px)');

        function activarModo() {
            var nuevoModo = esNoTactil() ? 'notactil' : 'mobile';
            if (nuevoModo === modoActual) return;

            if (modoActual === 'notactil' && instanciaNoTactil) {
                instanciaNoTactil.destruir();
                instanciaNoTactil = null;
            }
            if (modoActual === 'mobile' && instanciaMobile) {
                instanciaMobile.limpiar();
            }

            modoActual = nuevoModo;

            if (nuevoModo === 'notactil') {
                if (instanciaMobile) instanciaMobile.limpiar();
                instanciaNoTactil = iniciarNoTactil(seccion);
            } else {
                if (!instanciaMobile) {
                    instanciaMobile = iniciarMobile(seccion);
                } else {
                    instanciaMobile.posicionar();
                }
            }
        }

        mqHover.addEventListener('change', activarModo);
        mqWidth.addEventListener('change', activarModo);
        activarModo();
    }

    function init() {
        var secciones = document.querySelectorAll('[data-coleccion-swipe]');
        secciones.forEach(iniciarInstancia);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();